import { cx } from '@linaria/core';
import { useRef } from 'react';
import { Link } from '@provider/navigation';
import { Tooltip } from '@ui/kit';
import { HeartIcon } from '@ui/kit/icons';
import { triggerEventOnContainerClick } from '@utils/common';
import { PostloadedImage, Chevron } from '@utils/react';
import { useDeleteBookFavourite } from '../api/delete-bookshelf-favourite.mutation.js';
import { image, chevron, heartButton, book } from './_book-card.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function BookCard(props) {
  const ref = useRef(null);
  const handleDeleteMutation = useDeleteBookFavourite(props.book);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    jsxs("div", {
      ref: ref,
      className: cx(book),
      style: {
        aspectRatio: `${props.book.cover.width} / ${props.book.cover.height}`
      },
      onClick: evt => triggerEventOnContainerClick({
        ignores: ["a", "button"],
        ref,
        triggerSelector: "[data-link-target]"
      }, evt),
      children: [/*#__PURE__*/jsx(PostloadedImage, {
        className: image,
        src: props.book.cover.src.replace(/h=\d+/, ""),
        alt: props.book.title,
        sizes: "200px"
      }), /*#__PURE__*/jsx(Tooltip, {
        ariaType: "label",
        placement: "top",
        body: `Gå til '${props.book.title}'`,
        children: ref => /*#__PURE__*/jsx(Link, {
          className: chevron,
          ref: ref,
          href: props.book.url,
          target: "_blank",
          "data-link-target": true,
          children: /*#__PURE__*/jsx(Chevron, {
            size: 7,
            lineWidth: 2
          })
        })
      }), /*#__PURE__*/jsx(Tooltip, {
        ariaType: "description",
        placement: "top",
        body: "Fjern bogen fra dine favoritter",
        children: ref => /*#__PURE__*/jsx("button", {
          ref: ref,
          className: heartButton,
          onClick: evt => {
            evt.stopPropagation();
            evt.preventDefault();
            handleDeleteMutation.mutate();
          },
          "aria-label": "Fjern markering som favorit",
          children: /*#__PURE__*/jsx(HeartIcon, {})
        })
      })]
    })
  );
}

export { BookCard };
//# sourceMappingURL=_book-card.js.map
